import { useRef } from 'react';
import { Backdrop } from '@mui/material';
import LogoLoader from 'assets/images/logoNoBg.png';
import {
  SlideContainer,
  StyledBackDropContainer,
} from 'components/CustomBackDrop/CustomBackDrop.styled';
import { GlobalVariables } from 'config/constant';
import { translate } from 'locales/i18n';

export default function CustomBackDrop({ includeText = true }: { includeText?: boolean }) {
  const containerRef = useRef(null);
  return (
    <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 20 }} open={true}>
      <StyledBackDropContainer ref={containerRef}>
        <SlideContainer>
          <img
            src={LogoLoader}
            alt={GlobalVariables.File.Image.DefaultAlt}
            height={100}
            width={100}
          />
        </SlideContainer>
        {includeText && (
          <span style={{ color: 'white', marginTop: '20px', marginLeft: '20px' }}>
            {translate('common.data_loading')}
          </span>
        )}
      </StyledBackDropContainer>
    </Backdrop>
  );
}
